__turbopack_context__.v({
  "bgImageDesktop": "ResponsiveParallaxBackgroundImages-module__aS86fa__bgImageDesktop",
  "bgImageMobile": "ResponsiveParallaxBackgroundImages-module__aS86fa__bgImageMobile",
  "parallaxBackgroundImg": "ResponsiveParallaxBackgroundImages-module__aS86fa__parallaxBackgroundImg",
});
